
import { initializeApp } from 'firebase/app';
import { GoogleAuthProvider, getAuth, signInWithPopup,
        signInWithEmailAndPassword, createUserWithEmailAndPassword,
        sendPasswordResetEmail, signOut } from 'firebase/auth';
import { getFirestore, query, doc, getDocs, collection, 
        where, addDoc, updateDoc, deleteDoc, getDoc } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyBPVdWNIZFJQROo-M0JnDLh3gWMwvkvTiY",
    authDomain: "navigation-f0867.firebaseapp.com",
    projectId: "navigation-f0867",
    storageBucket: "navigation-f0867.appspot.com",
    messagingSenderId: "1042835926673",
    appId: "1:1042835926673:web:c2355a1514173860ba9930",
    measurementId: "G-FFCS02SFVP"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const googleProvider = new GoogleAuthProvider();

const signInWithGoogle = async () => {
    try {
        const res = await signInWithPopup(auth, googleProvider);
        const user = res.user;
        const q = query(collection(db, "users"), where("uid", "==", user.id) );
        const docs = await getDocs(q);
        if (docs.docs.length === 0) {
            await addDoc(collection(db, "users"), {
                uid: user.id,
                name: user.displayName,
                authProvider: "google",
                email: user.email,
            });
        }
    } catch (error) {
        console.log('error logIn with Google '+error);
        alert(error.message);
    }
}

const logInWithEmailAndPassword = async (email, password) => {
    try {
        await signInWithEmailAndPassword(auth, email, password);
        console.log('logueado con éxito! ');
    }catch (error) {
        switch (error.code){
            case 'auth/user-not-found':
                alert('Usuario o contraseña no validos!');
                break;
            default:
                alert('Ocurrio un error inesperado, por favor recargue la página!');
                break;
        }
        console.log('Novedad al iniciar sesión con usuario y contraseña '+ error);
        alert(error.message);
    }
}

const registerWithEmailAndPassword = async (name, email, password) => {
    try {
        const res = await createUserWithEmailAndPassword(auth, email, password);
        const user = res.user;
        await addDoc(collection(db, "users"), {
            uid: user.uid,
            name,
            authProvider: "local",
            email,
        });
    }catch (error) {
        console.log('Novedad registrando nuevo usuario '+error);
        switch(error.code) {
            case 'auth/email-already-in-use':
                alert('Correo electrónico ya se encuentra registrado!');
                break;
            case 'auth/weak-password':
                alert('Contraseña debe ser mayor a 6 caracteres!');
                break;
            default:
                alert('Ocurrio un error inesperado, por favor recargue la página!');
                break;
        }
    }
}

const sendPasswordReset = async (email) => {
    try {
        await sendPasswordResetEmail(auth, email);
        alert('Password reset link sent! ;)');
    }catch (error) {
        console.log('error sending password reset '+error);
        switch(error.code) {
            case 'auth/missing-email':
                alert('Correo no registrado!');
                break;
            default:
            alert('Ocurrio un error inesperado, por favor recargue la página!');
            break;
        }
    }
};


const logout = () => {
    signOut(auth);
};

const colRefMeasures = collection(db, 'DTMeasures');
const colRefReduccion = collection(db, 'DTReducciones')
const colRefYears = collection(db, 'DTYears');
const colRefBauMitigacion = collection(db, 'DTBauMitigacion');
const colRefCompensacion = collection(db, 'DTCompensacion');
const colRefCompensacionGrupos = collection(db, 'DTCompensacionGrupos');

const getBauMitigacion = async () => {
    try {
        const bauMitigacion = await getDocs(colRefBauMitigacion);
        //console.log('Bau Mitigacion desde servidor Firebase');
        //console.log(bauMitigacion);
        return bauMitigacion;
    }catch(error) {
        console.log('error obteniendo bauMitigacion '+error);
        return false;
    }
}

const getReducciones = async () => {
    try {
        const reducciones = await getDocs(colRefReduccion);
        //console.log('reducciones desde servidor Firebase');
        //console.log(reducciones);
        return reducciones;
    }catch(error) {
        console.log('error obteniendo reducciones '+error);
        return false;
    }
}

const getCompensacion = async () => {
    try {
        const compensacion = await getDocs(colRefCompensacion);
        console.log('compensaciones desde servidor Firebase= ');
        console.log(compensacion)
        return compensacion;
    }catch(error) {
        console.log('Error obteniendo datos de compensacion desde Firebase')
        return false;
    }
}

const getCompensacionGrupos = async () => {
    try {
        const compenGrupos = await getDocs(colRefCompensacionGrupos);
        console.log('compensaciones grupos desde servidor Firebase= ');
        console.log(compenGrupos)
        return compenGrupos;
    }catch(error) {
        console.log('Error obteniendo datos de compensacion desde Firebase')
        return false;
    }
}
const updateCompensacionGrupos = async () => {
    try {
        colRefCompensacionGrupos.doc(document.id).update({Especies: 'Especies Nuevas y totumos'});
    }catch(error) {
        console.log('Error editando datos en grupos de compesación.')
    }
}

const getYears = async () => {
    try {
        const years = getDocs(colRefYears)
        return years;
    }catch (error) {
        console.log('error obteniendo los years '+error)
        return false;
    }
}
const getMeasuresById = async (id) => {
    try{//const measureRef = doc(db, 'DTMeasures', newData.id);
        const docRef = doc(db, 'DTMeasures', id);
        const docMeasure = await getDoc(docRef);
        if (docMeasure.exists()) {
            console.log(docMeasure);
            console.log(docMeasure.id);
            return docMeasure.data();
        }else{
            return false;
        }
    }catch(error){
        console.log('Error opteniendo la Measure by Id'+error);
        return false;
    }
}

// const getMeasures1 = async () => {
//     try{
//         let measuresServer = [];
//         const q = query(colRefMeasures);
        
//         const fulDocs =  await getDocs(q);
//         fulDocs.docs.forEach((doc) => {
//             measuresServer.push({ ...doc.data(), id: doc.id });
//         })
//         console.log('Enviando la consulta retorna datos...');
//         console.log(measuresServer);
//     }catch(error) {
//         console.log('error consultando query por años ')
//         return false;
//     }
//     //return await getDocs(colRefMeasures);
// }
//getMeasures1();
const getMeasures = async (year) => {
    try{
        const q = query(colRefMeasures, where("year", "==", year));
        console.log('Enviando la consulta retorna datos...')
        return await getDocs(q);
    }catch(error) {
        console.log('error consultando query por años '+year)
        return false;
    }
    //return await getDocs(colRefMeasures);
}

const guardarReduccion = async (reduccion) => {
    try {
        const docRedSave = await addDoc(colRefReduccion, reduccion);
        console.log('Documento reduccion with ID: ', docRedSave.id);
        return true;
    }catch (error) {
        console.log('Error guardando '+error);
        return false;
    }
}

const guardarCompensacion = async (compensacion) => {
    try {
        const docComSave = await addDoc(colRefCompensacion, compensacion);
        console.log('Documento conpensación with ID: ', docComSave.id);
        return true;
    }catch (error) {
        console.log('Error guardando '+error);
        return false;
    }
}

const guardarMeasure = async (measure) => {
    try{
        const docMeasureSave = await addDoc(colRefMeasures, measure)
        console.log("Document written with ID: ", docMeasureSave.id);
        return true;
    }catch (error){
        console.log('error guardando '+ error)
        return false;
    }    
}

const deleteMeasure = async (key) => {
    try {
        const measureBorrar = doc(db, 'DTMeasures', key);
        console.log('key borrar:: '+measureBorrar.id);
        await deleteDoc(doc(db, 'DTMeasures', measureBorrar.id));
        console.log('BORRADO exitoso :: '+measureBorrar.id);
        return true;
    }catch (error){
        console.log('error '+error);
        return false;
    }
}

/* TODO Borrado masivo */
// function borrarMeasuresGrainpro() {
//     const measure_delete = []
//     measure_delete.map(MeaDelId =>{
//         deleteMeasure(MeaDelId);
//     });
// }
//borrarMeasuresGrainpro();
/* TODO Borrado masivo */

const deleteCompensacion = async (key) => {
    try {
        const compensacionBorrar = doc(db, 'DTCompensacion', key);
        console.log('key borrar:: '+compensacionBorrar.id);
        await deleteDoc(doc(db, 'DTCompensacion', compensacionBorrar.id));
        console.log('BORRADO exitoso :: '+compensacionBorrar.id);
        return true;
    }catch (error){
        console.log('error '+error);
        return false;
    }
}

const updateMeasure = async (measureUpdate, id) => {
    const docRef = doc(db, 'DTMeasures', id);
    try {
        console.log(docRef)
        await updateDoc(docRef, measureUpdate).then(() => {
            console.log('Measure actualizado id = '+id);
            return true;
        })
    }catch(err){
        console.log(err)
        return false;
    }
}

///********* FUNCION PARA REALIZAR CARGUE MASIVO DE DATOS***********/

// var entradas = []

// let total = 0;
// const insertarDoc = () => {
//   entradas.forEach(function(obj) {
//         try {
//           addDoc(colRefMeasures, obj);
//           console.log('se adiciono el objeto:: ');
//           total = total + Number(obj.resultado_kgco2);
//         }catch(err){
//           console.log(err);
//         }
          
//       //}
//   });
//   console.log('total resultados:: '+total);
// }
// insertarDoc();

//const [email, setEmail] = React.useState('');
const emailValidation=(emailDato) => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if(!emailDato || regex.test(emailDato) === false){
        return false;
    }
    return true;
}

const cat_fibtexFromServer1 = {
    transporte:{ 
        terrestre:{   
            id: 2,
            formula:'distancia_km*peso_ton*591/1000', 
            nombre: "Transporte terrestre",
            fe:591, 
            fe_camion_turbo:591,
            fe_camion_pesado:336,
            fe_automovil:160,
            fe_tractomula:163,
            fe_bus:1.0779692670133, 
            fe_tren:1.0779692670133
        }, aereo:{
            id: 3,
            formula_carga:'distancia_km*peso_ton*1.32', 
            formula_nacional:'distancia_km*numero_recorridos*175.3/1000',
            formula_internacional:'Kilometros*aereo_cantidad_recorridos*110.6/1000', 
            fe_nacional:175.3, 
            fe_internacional:110.6, 
            fe_carga:1.32, 
            nombre: "Transporte aéreo"
        },maritima:{
            id: 4,
            formula:'distancia_km*peso_ton*6/1000', 
            fe:6,   
            nombre: "Transporte marítima"
        }
    },
    energia:{
        consumo_energia:{
            id: 6, 
            fe:0.225, 
            formula:'0.225*consumo_energia_anual_mwh', 
            nombre: "Consumo de energía eléctrica", 
            formula_factura:"kilovatio_hora * 0.203", 
            fe_factura: "0,203"
        }
    }
}
const cat_fibtexFromServer = [
    {
        id:1, 
        nombre: "Transporte", 
        subcategorias: [
        {   id: 2,formula:'distancia_km*peso_ton*591/1000', 
            nombre: "Transporte terrestre",
            fe:591, 
            fe_camion_turbo:591,
            fe_camion_pesado:336,
            fe_automovil:160,
            fe_tractomula:163,
            fe_bus:1.0779692670133, 
            fe_tren:1.0779692670133},
        {id: 3,formula_carga:'distancia_km*peso_ton*1.32', formula_nacional:'distancia_km*numero_recorridos*175.3/1000',formula_internacional:'Kilometros*aereo_cantidad_recorridos*110.6/1000', fe_nacional:175.3, fe_internacional:110.6, fe_carga:1.32, nombre: "Transporte aéreo"},
        {id: 4,formula:'distancia_km*peso_ton*6/1000', fe:6,   nombre: "Transporte marítima"},
            //{ nombre: 'col_ter_bus_gsol_co2e_kmt', valor: 1.0779692670133, unidad: 'kg CO2e/km', datoDeEntrada1: 'kilometros', datoDeEntrada2: '# vehiculos', datoDeEntrada3: '', Subcategoria: 'Transporte terrestre ' },
        ]
    },{
        id:5,
        nombre: "Consumo de energía",
        subcategorias: [
        {id: 6, fe:0.225, formula:'0.225*consumo_energia_anual_mwh', nombre: "Consumo de energía eléctrica", formula_factura:"kilovatio_hora * 0.203", fe_factura: "0,203"},
        ] //{ nombre: 'col_cel_con_elec_co2e_con', fe: 0.203, unidad: 'kg CO2e/kWh', datoDeEntrada1: 'kilovatio-hora (kWh)', datoDeEntrada2: '', datoDeEntrada3: '', Subcategoria: 'Consumo de electricidad' },
    }
]

const cat_reduccion = [
    {
      id:1, 
      nombre: "Transporte", 
      subcategorias: [
        {
          id: 1, 
          nombre: 'Transporte terrestre', 
          emisiones:[
              {id: 1, nombre: 'Transporte trabajo', code: 'TTtrabajo'},
              {id: 2, nombre: 'Transporte materia prima', code: 'TTmateriaPrima'},
          ]
        },{
          id: 2, 
          nombre: 'Transporte aéreo', 
          emisiones:[
              {id: 1, nombre: 'Transporte aéreo', code: 'Aereo'},
          ]
        },{
          id: 3, 
          nombre: 'Transporte marítimo', 
          emisiones:[
              {id: 1, nombre: 'Transporte marítimo', code: 'Maritimo'}
          ]
        }
      ]
    },{
      id:2,
      nombre: "Consumo de energía",
      subcategorias: [
        { id: 1, 
          nombre: "Consumo de energía eléctrica",
          emisiones: [
            {id:1, nombre: 'Consumo de energía', code: 'Energia'}
          ]
        },
      ] 
    }
]

export { auth, db, colRefMeasures, signInWithGoogle, logInWithEmailAndPassword, registerWithEmailAndPassword,
        sendPasswordReset, logout, guardarMeasure, guardarCompensacion, guardarReduccion, getMeasures,
        getBauMitigacion, getYears, getReducciones, getCompensacion, getCompensacionGrupos, updateCompensacionGrupos, updateMeasure, deleteCompensacion,
        deleteMeasure, emailValidation, getMeasuresById, cat_fibtexFromServer, cat_fibtexFromServer1, cat_reduccion };


